import { Methods } from "@newview/infrastructure";
import {NewviewWebsiteBaseApi} from "./NewviewWebsiteBaseApi";


export class WebsiteCategoryInfoApi extends NewviewWebsiteBaseApi {

  public get ControllerName(): any {
    return 'website-category-info'
  }

  /**
       * 根据id 逻辑删除
       * @param idParam 分类id 
       * @returns 
       */
  public delVerifyById(idParam) {
 
    return this.send({id:idParam}, "delVerifyById", this.Methods.GET)
  }



}